import { URLConfig } from "../network/urlStore";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";
export const substituteProductInFieldBook = (
  requestPayload: any,
  queryparams: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.substituteProductInFieldBookURL();
  for (const param of queryparams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);

        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching Inventory data", error);
      }
    );
  });
};
export const substituteProductInTrial = (
  requestPayload: any,
  id: string,
  queryparams?: Array<{
    key: AgTechQueryParam;
    value: boolean[];
  }>
): Observable<any> => {
  let url = URLConfig.substituteProductInTrialURL(id);
  for (const param of queryparams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching Inventory data", error);
      }
    );
  });
};
export const getReasonsToDiscardPlot = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.getReasonsToDiscardPlotURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          subscriber.next(res);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};

export const substituteProductInDemoTrials = (
  requestPayload: any,
  demoTrialProductId: string,
  queryparams?: Array<{
    key: AgTechQueryParam;
    value: boolean[];
  }>
): Observable<any> => {
  let url = URLConfig.substituteProductInDemoTrialURL(demoTrialProductId);
  for (const param of queryparams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);

        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching Inventory data", error);
      }
    );
  });
};
